
const prosperBoxShadow = '#0000000a';
const prosperBoxShadow2 = '#0000002E';
const prosperBoxGreen = '#71BB6F';
const prosperBorderGreen = '#55A752';
const prosperBoxRed = '#D1347D';
const prosperBoxRedStatus = '#D50000';
const prosperCursorGrayDark = '#b8c2c7';
const prosperCursorGray = '#e7ecef';
const prosperBlackStatus = '#35424E';
const prosperGrayBorder = '#dddbdb';
const prosperRedBorder = '#c3075e';
const prosperOrange = '#EE7219';
const prosperInboxBg = '#F5F7F8';
const prosperGreenBorder = '#60af5e';
const prosperGrayDisabled = '#caced1';
const prosperGreenBg = '#D4EAD3';
const prosperGrayBorder2 = '#AAAAAA';
const prosperDisabledBg = '#C9CCD0';
const prosperProBg = '#4C4B73';
const prosperProBgGrayIcon = '#7A7997';
const policeBlue = '#3D4D5C';
const pewterBlue = '#95A9BC';
const shadowBlue = '#7990A5';
const vividTangelo = '#F36B21';
const prosperGrayDisabledText = '#aeb0b3';
const blackCoral = '#596571';
const prosperBoxGrayText = '#a8bfcb';
const prosperOrange2 = '#e26206';
const grayOptional = '#8a969b';
const boxInset = '#ccd3d8';
const lightGray = '#e7edf0';
const gray = '#959CA3';
const radioBoxBlack = '#555555';
const maastrichtBlue = '#082330';
const coolGrey = '#8796A0';
const smallGray = '#7f8e99';
const azureishWhite3 = '#E1EFF7';
const azureishWhite4 = '#CEE6F4';
const lightBlue = '#AFD0E3';
const darkGoldenrod = '#C6800D';
const philippineSilver = '#ABB1B6';
const auroMetalSaurus = '#687886';
const romanSilver = '#868d93';
const lightSlateGray = '#73899d';
const iguanaGreen = '#71bb6f';
const lightGray2 = '#D3D3D3';
const wildBlueYonder = '#a2bbd3';
const quickSilver = '#A5A5A5';
const prosperOuterSpace = '#454545';
const dimGray = '#696969';
const bubbles = '#e5f4fa';
const paleCerulean = '#a1ccde';
const cello = '#43505b';
const veryLightGrey = '#C7C7C7';
const zambezi = '#585858';
const pattensBlue = '#C9DAE3';
const midnight = '#212F3C';
const teaGreen = '#c2eac1';
const mauve = '#D6BBFC';
const jetBlack = '#00000010';
const brightGrey = '#555c69';
const fog = '#D9D2E5';
const prosperPurple = '#59368c';
const dimGray2 = '#707070';
const midGrey = '#5F6B74';
const blackPearl = '#1A2027';
const SilverSand = '#C0C6C8';
const lightSilver = '#D2DADE';
const transparentYellow = '#FCCD0E80';
const Seashell = '#FEEDED';
const roseMadder = '#E53935';
const kryptoniteGreen = '#43A047';
const sunCrete = '#FB8C00';
const laceVeil = '#ECEBEB';
const prosperAIPurple = '#7C3AED';
const prosperWarningLight = '#fffbea';
const prosperWarningMain = '#fdd835';
const prosperWarningDark = '#856404';
const prosperSuccessMain = '#4caf50';
const prosperGrey50 = '#f8f9fa';
const prosperGrey100 = '#f0f0f0';
const aiAcordionBg = '#f1f5f9';

const prosper = {
  blackPearl,
  midGrey,
  fog,
  mauve,
  lightBlue,
  prosperBoxShadow,
  prosperBoxShadow2,
  prosperBoxGreen,
  prosperBorderGreen,
  prosperBoxRed,
  prosperBoxRedStatus,
  prosperCursorGrayDark,
  prosperCursorGray,
  prosperBlackStatus,
  prosperGrayBorder,
  prosperRedBorder,
  prosperOrange,
  prosperInboxBg,
  prosperGreenBorder,
  prosperGrayDisabled,
  prosperGreenBg,
  prosperGrayBorder2,
  prosperDisabledBg,
  prosperProBg,
  prosperProBgGrayIcon,
  policeBlue,
  pewterBlue,
  shadowBlue,
  vividTangelo,
  prosperGrayDisabledText,
  blackCoral,
  prosperBoxGrayText,
  prosperOrange2,
  grayOptional,
  boxInset,
  lightGray,
  gray,
  radioBoxBlack,
  maastrichtBlue,
  coolGrey,
  smallGray,
  azureishWhite3,
  azureishWhite4,
  darkGoldenrod,
  philippineSilver,
  auroMetalSaurus,
  romanSilver,
  lightSlateGray,
  iguanaGreen,
  lightGray2,
  wildBlueYonder,
  quickSilver,
  prosperOuterSpace,
  dimGray,
  dimGray2,
  bubbles,
  paleCerulean,
  cello,
  veryLightGrey,
  zambezi,
  pattensBlue,
  midnight,
  teaGreen,
  jetBlack,
  brightGrey,
  prosperPurple,
  SilverSand,
  lightSilver,
  transparentYellow,
  Seashell,
  roseMadder,
  kryptoniteGreen,
  sunCrete,
  laceVeil,
  prosperAIPurple,
  prosperWarningLight,
  prosperWarningMain,
  prosperWarningDark,
  prosperSuccessMain,
  prosperGrey50,
  prosperGrey100,
  aiAcordionBg,
};

module.exports = prosper;
